import React, { useEffect } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Pagination from "@material-ui/lab/Pagination";
import { Button, Grid, Box, TablePagination, Paper } from "@material-ui/core";

import LobConstants from "../../../../constants/LobConstants";

import useStyles from "../../../../themes/makeStyles";
import { useHistory } from "react-router-dom";
import Hidden from "@material-ui/core/Hidden";
import clsx from "clsx";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

const DEFAULT_PAGINATION_OPTIONS =
  LobConstants.DEFAULT_LIST_VIEW_PAGINATION_OPTIONS;

function SearchResults(props) {
  const classes = useStyles();
  const history = useHistory();
  const [tableDataList, setTableDataList] = React.useState(props.tableData);
  const [page, setPage] = React.useState(props.page);
  const [rowsPerPage, setRowsPerPage] = React.useState(
    DEFAULT_PAGINATION_OPTIONS.DEFAULT_RECORDS_PER_PAGE
  );
  const [datasorted, setDatasorted] = React.useState(true);
  useEffect(() => {
    console.log("Props Table Data==", props.tableData);
  }, [props.tableData]);
  const TableHeadList = (props) => {
    return (
      <div className="tblhd">
        <Box
          display="flex"
          py={1}
          style={{ cursor: "pointer" }}
          alignItems="center"
        >
          {props.tableHeader.map((thead, index) => {
            return (
              <Box
                key={index}
                p={1}
                flexGrow={1}
                flexBasis={0}
                onClick={() => hadleDataSort(thead)}
              >
                {thead.label}
              </Box>
            );
          })}
        </Box>
      </div>
    );
  };

  const hadleDataSort = (thead) => {
    let theadValue = thead.value;
    let sortTableData = tableDataList;
    if (datasorted) {
      setTableDataList(
        sortTableData.sort(function (a, b) {
          var keyA = a[theadValue],
            keyB = b[theadValue];
          // Compare the 2 dates
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        })
      );
      setDatasorted(false);
    } else {
      setTableDataList(
        sortTableData.sort(function (a, b) {
          var keyA = a[theadValue],
            keyB = b[theadValue];
          // Compare the 2 dates
          if (keyA > keyB) return -1;
          if (keyA < keyB) return 1;
          return 0;
        })
      );
      setDatasorted(true);
    }
  };

  const navigateToRecordDamageWagon = (event, selectedRec) => {
    event.stopPropagation();

    history.push({
      pathname: `/${LobConstants.LOB}/maintenance/currentcomposition/createcurrentcomposition`,
    });
  };

  const TableDataList = (props) => {
    const [collapsedRow, setCollapsedRow] = React.useState();
    console.log("Props Table Data Here ", props.tableData);

    return (
      <div className="evenOddBackground width-100">
        {props.tableData
          // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((n, index) => {
            return (
              <Box key={index} py={1}>
                <Paper elevation={1}>
                  <Accordion className="boxShadow ">
                    <Box className="innerBackground">
                      <AccordionSummary
                        expandIcon={<MoreHorizIcon className="expandIconDB" />}
                      >
                        <Grid container spacing={3} alignItems="center">
                          <Grid container item xs={12} spacing={1}>
                          <Grid item xs={3} sm={3}>
                              <Box my={1}>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.subText}
                                  >
                                    Rake Name
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.mainText}
                                  >
                                    {n.rake_name}
                                  </Typography>
                                </Grid>
                              </Box>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                              <Box my={1}>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.subText}
                                  >
                                    Schedule Type
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.mainText}
                                  >
                                    {n.schedule_type}
                                  </Typography>
                                </Grid>
                              </Box>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                              <Box my={1}>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.subText}
                                  >
                                    Rake Composition
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.mainText}
                                  >
                                    {n.rake_composition}
                                  </Typography>
                                </Grid>
                              </Box>
                            </Grid>
                            <Grid item xs={3} sm={3}>
                              <Box my={1}>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.subText}
                                  >
                                    Last Unlaoding Point
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.mainText}
                                  >
                                    {n.last_unloading_point}
                                  </Typography>
                                </Grid>
                              </Box>
                            </Grid>
                            <Grid item xs={2} sm={2}>
                              <Box my={1}>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.subText}
                                  >
                                    Status
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h6"
                                    className={classes.mainText}
                                  >
                                    {n.schedule_status}
                                  </Typography>
                                </Grid>
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                    </Box>

                    <AccordionDetails>
                      <Box py={1} style={{ cursor: "pointer" }} width={1}>
                        <Grid container spacing={2} justify="center">
                          <Grid item xs={12} sm={12}>
                            <Grid item xs={12} align="center">
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.subTextButton}
                                onClick={(event) =>
                                  navigateToCargoMaster(event, n)
                                }
                              >
                                View More / Edit Schedule Maintenance Details
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid> 
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </Paper>
              </Box>
            );
          })}
      </div>
    );
  };
  const navigateToCargoMaster = (event, selectedRec) => {
    event.stopPropagation();
    history.push({
      pathname: `/${LobConstants.LOB}/maintenance/schedulemaintenance/createschedulemaintenance`,
      isEdit: true,
      schedule_maintenance_id: selectedRec.schedule_maintenance_id,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1);
  };
  return (
    <div>
      {props.searchResultsEmpty &&
        (!props.tableData || props.tableData.length == 0) && (
          <Box py={1}>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Grid item xs={12} sm>
                <Box my={1}>
                  <h3 classname={classes.secondHeading}>No Records Found</h3>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      {props.tableData && props.tableData.length > 0 ? (
        <>
          <TableDataList tableData={props.tableData} />
          <Grid container justify="flex-end">
            <Pagination
              count={props.paginationInfo.totalpages}
              color="primary"
              onChange={props.handleChangePage}
              page={props.page}
            />
          </Grid>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}

export default SearchResults;
